import * as React from 'react';
import { useStateValue } from "@/providers/state-provider";
import { FoodCategory, FoodItem } from '@/root/types';
import { NavMenuButton } from './nav-menu-button';
import { SingleFoodItem } from '../food-item';

interface MenuCatsProps {
  categories: FoodCategory[] | null;
  items: FoodItem[] | null;
  sectionsRef: React.RefObject<(HTMLElement | null)[]>;
}

export const MenuCats: React.FC<MenuCatsProps> = ({ categories, items, sectionsRef }) => {
  if (!categories || !items) return null;


  return (
    <div className='menuCats mt-5 sm:mt-0'>
    {categories && items && categories.map((category: FoodCategory, index) => {
          const filteredItems = {
            items: items ? items.filter(item => item.category === category.urlParam) : []
          };
          return (
            <section
              key={index}
              ref={(el) => {
                if (sectionsRef.current) {
                  sectionsRef.current[index] = el;
                }
              }}
            >
              <div className="flex flex-row w-full mt-4 mb-4">
                <h1 className="text-black font-berthold text-2xl leading-none">
                  {category.name}
                </h1>
              </div>
              <div className="w-full mb-12">
                <div className="flex flex-wrap gap-3 sm:gap-4">
                  {filteredItems && filteredItems.items && filteredItems.items.map((item: FoodItem) => (
                    <SingleFoodItem key={`single-item-${item.id}`} item={item} />
                  ))}
                </div>
              </div>
              <hr className='divider' />
            </section>
          )
        })}
    </div>
  );
};
